import React, { useEffect } from 'react';
import {
	AirportCodeHolidayCheck,
	AirportCodeKey,
	AirportCodeTravelSupermarket,
} from '@app/model/market_state/AirportCode';
import MenuButtonFilter, { MenuButtonFilterItem } from '@app/component/menu/MenuButtonFilter';
import ParityFilterInput from '@app/model/parity/input/ParityFilterInput';


type ParityFilterAirportCodesCompareFilterProps = {
	filter: ParityFilterInput;
	onFilter: (filter: ParityFilterInput) => void;
};

export const ParityFilterAirportCodesCompareFilter = React.memo(
	function ParityFilterAirportCodesCompareFilter({ filter, onFilter }: ParityFilterAirportCodesCompareFilterProps) {

		useEffect(() => {
			onFilter({ ...filter, compareAirportCodes: [] });
		}, [filter.airportCode]);


		let menuItems = [
			...Object.entries(AirportCodeTravelSupermarket),
			...Object.entries(AirportCodeHolidayCheck),
		].map<MenuButtonFilterItem<AirportCodeKey>>(([value, airport]) => ({
			value: value as AirportCodeKey,
			name: airport.name,
		}));

		if(!!filter.airportCode) {
			menuItems = menuItems.filter(item => item.value !== filter.airportCode);
		}

		return <MenuButtonFilter menuItems={menuItems}
														 selectedValues={filter.compareAirportCodes}
														 onMultiSelect={(values) => onFilter({ ...filter, compareAirportCodes: values })}
														 multiSelectDisplayText={(selected) =>
															 selected.length === 0 ? 'Compare to airports' :
																 selected.length > 1 ? `${selected.length} Airports` :
																	 selected[0].name
														 }
														 menuDescription="Please set up to 4 airports to compare with"
														 enableSearch
														 enableMultiSelect
														 maxMultiSelect={4}
														 searchPlaceholder="Filter airports" />;

	});
